export default __webpack_public_path__ + "static/media/vi.d87ebf8c.svg";